import React, {useRef} from 'react'
import Slider from "react-slick"
import {Button} from '../Button'


import './style.scss'

export const SliderHero = ({
    images,
    autoplay
    }) => {
    const sliderRef = useRef();

  return (
    <div className="container Slider">
      <div className="content">
        <Slider
          ref={sliderRef}
          arrows={false}
          dots={false}
          infinite={true}
          autoplay={autoplay === true}
          autoplaySpeed={5000}
          speed={160}
          autoHeight={true}
          slidesToShow={1}
          slidesToScroll={1}
          className={'slickSliderContainer'}
          pauseOnFocus={false}
          pauseOnHover={false}
          responsive={[{
            breakpoint: 480,
            settings: { centerMode: false }
          }]}>
          {images.map((item, index) => (
            <img src={item.original} alt={item.originalAlt} />
          ))}
        </Slider>
        <div className="sliderControls">
          <Button
            onClick={ () => sliderRef.current.slickPrev() }
            backgroundColor="#fff"
            color="#00924D"
            icon="chevron-left"
          >
          </Button>
          <Button
            onClick={ () => sliderRef.current.slickNext() }
            color="#00924D"
            backgroundColor="#fff"
            icon="chevron-right"
          >
          </Button>
        </div>
      </div>
            </div>
		);
}
